import CoreRouter from '../router/router'

const Logout = () =>{
    localStorage.removeItem(process.env.VUE_APP_NEURAXIS_TOKENNAME);
    localStorage.clear();
    CoreRouter.push({path:'/', replace: true});
}
export default Logout;